import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      maxWidth: '100%',
    },
    requiremmentList: {
      marginTop: 15,
    },
  };
});

export default useStyles;
